import { InQueueApp } from "in_queue/InQueueApp";
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useParams
} from "react-router-dom";
import { GeneratorType } from "types/generatorType";
import { BusPageApp } from "./BusPageApp";
import { DocumentationAuthenticationApp } from "./DocumentationAuthenticationApp";
import { PlatformHomePage } from "./platform/PlatformHomePage";
import { PlatformLayout } from "./platform/PlatformLayout";
import { ProspectingApp } from "./ProspectingApp";

export const SCREENING_VIEWS_PATH = "screening-views";
export const IN_QUEUE_PATH = "portfolio";
export const PROSPECTING_PATH = "prospecting";

// TODO: Consolidate all route path constants and URL helpers here
// (e.g., getUrlForScreeningView from screeningViewType.tsx)
export const BUS_PAGE_PATH = "bus";
export const BUS_PAGE_FUEL_TYPE_PARAM = "fuel_type";
export const getUrlForBusPage = (
    niraBusId: string,
    generatorType?: GeneratorType
): string => {
    const path = `/${PROSPECTING_PATH}/${BUS_PAGE_PATH}/${niraBusId}`;
    return generatorType === undefined
        ? path
        : `${path}?${new URLSearchParams({
              [BUS_PAGE_FUEL_TYPE_PARAM]: generatorType
          })}`;
};

export const RouterApp: React.FC = () => {
    return (
        <Routes>
            <Route element={<PlatformLayout />}>
                <Route path="/" element={<PlatformHomePage />} />

                <Route
                    path={`/${PROSPECTING_PATH}`}
                    element={<ProspectingApp />}
                />
                <Route
                    path={`/${PROSPECTING_PATH}/:urlDirectory`}
                    element={<ProspectingApp />}
                />
                <Route
                    path={`/${PROSPECTING_PATH}/:urlDirectory/${SCREENING_VIEWS_PATH}/:screeningViewId`}
                    element={<ProspectingApp />}
                />
                <Route
                    path={`/${PROSPECTING_PATH}/${BUS_PAGE_PATH}/:niraBusId`}
                    element={<BusPageApp />}
                />

                <Route path={`/${IN_QUEUE_PATH}/*`} element={<InQueueApp />} />
            </Route>

            <Route
                path="/docs-authentication"
                element={<DocumentationAuthenticationApp />}
            />

            <Route
                path="/:urlDirectory/*"
                element={<LegacyProspectingRedirect />}
            />
        </Routes>
    );
};

/**
 * Redirects old Prospecting URLs (e.g. /MISO-solar) to the new
 * /prospecting/MISO-solar path.
 *
 * Uses useParams() instead of window.location.pathname so the redirect
 * only includes the segments captured by the /:urlDirectory/* pattern,
 * preventing infinite /prospecting/prospecting/… nesting if the catch-all
 * route ever matches a URL that already starts with /prospecting.
 */
const LegacyProspectingRedirect: React.FC = () => {
    const { urlDirectory, "*": splat } = useParams();
    const { search } = useLocation();
    const target = splat
        ? `/${PROSPECTING_PATH}/${urlDirectory}/${splat}${search}`
        : `/${PROSPECTING_PATH}/${urlDirectory}${search}`;
    return <Navigate to={target} replace />;
};
